<template>
  <v-dialog v-model="isShown" content-class="basket-payment-system-error-dialog" max-width="480" @click:outside.prevent="onClose">
    <v-card v-if="paymentSystem">
      <button class="basket-payment-system-error-dialog__close"
              @click="onClose">
        <svgicon name="cross"/>
      </button>

      <v-card-title class="justify-center text-center">
        Способ оплаты "{{ paymentSystem.label.toLowerCase() }}" недоступен для выбранного пункта назначения
      </v-card-title>

      <v-card-text class="justify-center text-center size-sm-md">
        Пожалуйста, выберите доступный способ оплаты:
        <v-radio-group v-model="paymentSystemId" @change="onPaymentSystemSelect">
          <v-radio v-for="(item, index) of availablePaymentSystems"
                   :value="item.id"
                   :key="'payment-system-'+index"
                   :class="'paymentSystem'+item.id">
            <template v-slot:label>
              <template v-if="item.hint">
                <div>
                  <div>{{ item.label }}</div>
                  <div class="size2 color-gray" v-html="item.hint"></div>
                </div>
              </template>
              <template v-else>
                {{ item.label }}
              </template>
            </template>
          </v-radio>
        </v-radio-group>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import {PAYMENT_SYSTEM_ID_CARD, PAYMENT_SYSTEM_ID_LINK, paymentSystems} from "@/store/payment";
import {objectToArray} from "@/utils/utils";
import {DESTINATION_MSK, DESTINATION_SPB} from "@/store/delivery";

export default {
  name: 'basket-payment-system-error-dialog',
  emits: ['close'],
  props: {
    isShown: {
      type: Boolean,
      default: false,
    },
    destinationId: {
      type: Number,
    },
    form: {
      type: Object,
    }
  },
  data() {
    return {
      paymentSystemId: null,
    }
  },
  computed: {
    paymentSystem() {
      return paymentSystems.find(el => el.id === this.form.paymentSystemId);
    },
    payments() {
      return this.$store.state.page.BasketController?.payments;
    },
    availablePaymentSystems() {
      let ps = [];

      paymentSystems.forEach((item) => {
        if (item.destinationIds.includes(this.destinationId)) {
          ps.push(item);
        }
      });

      const settings = objectToArray(this.$store.state.page.BasketController?.settings);
      let isPaymentSystemLinkAvailable = true;

      if (this.destinationId === DESTINATION_SPB) {
        isPaymentSystemLinkAvailable = !!settings?.find(el => el.CODE === 'IS_PAYMENT_SYSTEM_LINK_AVAILABLE_SPB');
      } else if (this.destinationId === DESTINATION_MSK) {
        isPaymentSystemLinkAvailable = !!settings?.find(el => el.CODE === 'IS_PAYMENT_SYSTEM_LINK_AVAILABLE_MSK');
      }

      /*if (!isPaymentSystemLinkAvailable) {
        ps = ps.filter(el => el.id !== PAYMENT_SYSTEM_ID_LINK);
      } else {
        ps = ps.filter(el => el.id !== PAYMENT_SYSTEM_ID_CARD);
      }*/

      ps = ps.filter(el => this.payments?.some(payment => Number(payment.ID) === el.id));

      return ps;
    }
  },
  methods: {
    async onPaymentSystemSelect(paymentSystemId) {
      await this.$nextTick();
      this.form.paymentSystemId = paymentSystemId;
      this.form.destinationId = this.destinationId;
      this.$emit('close');
      this.paymentSystemId = null;
    },
    onClose() {
      this.$emit('close');
    },
  }
}
</script>

<style lang="scss">
.basket-payment-system-error-dialog {
  &__close {
    position: absolute;
    top: 12px;
    right: 12px;
    color: $golden;
    width: 14px;
    height: 14px;

    &:hover {
      svg {
        stroke: $black;
      }
    }

    svg {
      width: 14px;
      height: 14px;
      margin-top: -9px;
      fill: none;
      stroke: $golden;
      @include transition();
    }
  }

  .v-card {
    &__title {
      word-break: normal;
    }
  }

  .v-input--radio-group__input {
    justify-content: center;
  }

  .v-radio {
    align-items: flex-start;

    .v-label {
      margin-top: 2px;
    }
  }
}
</style>